import { AccessGrantDto, AccessGrantSourceDto, GrantRole } from "../../../../autogen/bff-api";

export const organizationAssignableRoles: GrantRole[] = [
  GrantRole.Admin,
  GrantRole.SourcingCreator,
  GrantRole.SourcingViewer,
  GrantRole.ContractCreator,
  GrantRole.ContractViewer,
  GrantRole.ProjectCreator,
  GrantRole.ProjectViewer,
];

export const departmentAssignableRoles: GrantRole[] = [
  GrantRole.Admin,
  GrantRole.SourcingCreator,
  GrantRole.SourcingViewer,
  GrantRole.ProjectCreator,
  GrantRole.ProjectViewer,
  GrantRole.ContractCreator,
  GrantRole.ContractViewer,
];

export interface RoleGroup {
  role: GrantRole;
  departments: { id: string; name: string }[];
  fromEntra: boolean;
}

export const groupByRole = (grants: AccessGrantDto[]): RoleGroup[] => {
  const groups = new Map<GrantRole, RoleGroup>();
  grants.forEach((grant) => {
    const departmentId = grant.departmentId;
    if (departmentId) {
      const group = groups.get(grant.role) ?? { role: grant.role, departments: [], fromEntra: false };
      group.departments.push({ id: departmentId, name: grant.departmentName ?? "" });
      group.fromEntra = group.fromEntra || grant.source === AccessGrantSourceDto.Entra;
      groups.set(grant.role, group);
    }
  });
  return [...groups.values()];
};

export const organizationRoles = (grants: AccessGrantDto[]): AccessGrantDto[] =>
  grants.filter((grant) => !grant.departmentId);
